import { useFormContext } from 'react-hook-form';
import { lt } from '@mews/framework';
import { Grid, Stack, Typography } from '@optimus-web/core';
import { NumberInputField, SelectField } from '@mews-commander/form';
import { createOption } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { getCurrentEnterpriseAcceptedCurrencyCodes } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { useCommanderSelector } from '@mews-commander/utils';
import { CancellationPolicyFormField } from '../types';
import { FormValues } from './schema';
import { FeeExtentField } from './fields';

export const CancellationPolicyFeesFormSection = () => {
    const acceptedCurrencyCodes: string[] = useCommanderSelector(getCurrentEnterpriseAcceptedCurrencyCodes);

    const { watch } = useFormContext<FormValues>();

    const bookablePeriod = watch(CancellationPolicyFormField.BookablePeriod);
    const percentage = Number(watch(CancellationPolicyFormField.RelativeFee));
    const shouldDisabledFeeExtentAndMaxPeriodsFields = percentage === 0;

    return (
        <Stack vertical distribution="space-between" spacing="200">
            <Typography textStyle="titleSmallStrong" as="div">
                {lt('Fee')}
            </Typography>
            <Grid templateColumns="1fr 1fr 1fr" gap="100">
                <NumberInputField
                    name={CancellationPolicyFormField.RelativeFee}
                    label={lt('GeneralPercentage')}
                    type="number"
                    suffix={UnicodeEntity.Percent}
                />
                <FeeExtentField bookablePeriod={bookablePeriod} disabled={shouldDisabledFeeExtentAndMaxPeriodsFields} />
                <NumberInputField
                    name={CancellationPolicyFormField.FeeMaximumTimeUnits}
                    label={lt('CancellationPolicyMaxPeriodsToApplyFee')}
                    type="number"
                    disabled={shouldDisabledFeeExtentAndMaxPeriodsFields}
                />
            </Grid>
            <Grid templateColumns="4fr 1fr" gap="100">
                <NumberInputField
                    name={CancellationPolicyFormField.AbsoluteFee}
                    label={lt('GeneralFixedAmount')}
                    type="number"
                />
                <SelectField
                    name={CancellationPolicyFormField.AbsoluteFeeCurrencyCode}
                    options={acceptedCurrencyCodes.map((currencyCode) =>
                        createOption({
                            value: currencyCode,
                            label: currencyCode,
                        })
                    )}
                    label={lt('Currency')}
                    required
                />
            </Grid>
        </Stack>
    );
};
